<template lang="pug">
  b-container#ScannerContainer(:class="{ 'scanner-container--driver': isDriver }")
    scanner-in-store
</template>
<script>
import { mapGetters } from 'vuex'
import ScannerInStore from '../components/delivery/ScannerInStore.vue'
import { isDriverRole } from '../constants/userRoles'
export default {
  components: {
    ScannerInStore
  },
  computed: {
    ...mapGetters(['user']),
    isDriver() {
      return this.user && isDriverRole(this.user.role)
    }
  }
}
</script>
<style lang="scss">
#ScannerContainer {
  --scanner-page-height: calc(100vh - 300px);
  background-color: #191919;
  max-width: 600px;
  height: var(--scanner-page-height);
  min-height: 360px;
  padding-top: 15px;
  padding-bottom: 15px;

  @supports (height: 100dvh) {
    --scanner-page-height: calc(100dvh - 300px);
  }

  &.scanner-container--driver {
    --scanner-page-height: calc(100vh - 100px);

    @supports (height: 100dvh) {
      --scanner-page-height: calc(100dvh - 100px);
    }
  }

  @media (max-width: 768px) {
    --scanner-page-height: calc(100vh - 290px);

    @supports (height: 100dvh) {
      --scanner-page-height: calc(100dvh - 290px);
    }

    &.scanner-container--driver {
      --scanner-page-height: calc(100vh - 70px);

      @supports (height: 100dvh) {
        --scanner-page-height: calc(100dvh - 70px);
      }
    }
  }
}
</style>
